<!-- <button mat-mini-fab class="icon-btn secondary-class" [matMenuTriggerFor]="menu">+3</button>
<mat-menu #menu="matMenu" class="menu-container"  xPosition="before">
    <mat-list (click)="$event.stopPropagation();$event.preventDefault();">
        
        <input class="list-title" type = "text" placeholder="user mail"/>
        <mat-divider></mat-divider>
        <mat-list-item>
            <div class="list-container">
                <h6 class="list-item-content">shivakumar@chn.aithent.com</h6>
            </div>
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item>
            <div class="list-container">
                <h6 class="list-item-content">tlavanya@chn.aithent.com</h6>
            </div>
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item>
            <div class="list-container">
                <h6 class="list-item-content">sivanesan@chn.aithent.com</h6>
            </div>
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item>
            <div class="list-container">
                <h6 class="list-item-content">praveenputta@chn.aithent.com</h6>
            </div>
        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item>
            <div class="list-container">
                <h6 class="list-item-content">lakshmikala@chn.aithent.com</h6>
            </div>
        </mat-list-item>
    </mat-list>
</mat-menu> -->
<button mat-mini-fab class="icon-btn secondary-class" [matMenuTriggerFor]="menu">+3</button>
<mat-menu #menu="matMenu"  xPosition="before">
    <form class="example-form" (click)="$event.stopPropagation();$event.preventDefault();">
        <mat-form-field class="example-full-width">
          <mat-label>Enter Participants</mat-label>
          <input type="text"
                 placeholder="Mail ID"
                 aria-label="Number"
                 matInput
                 [formControl]="myControl"
                 [matAutocomplete]="auto">
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
              {{option}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </form>
</mat-menu>